import React, { useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";
import { languageHelper } from "../../../config/helperFunctions";

function CheckBox({ row, user, status, handleError }) {
    const initialChecked = row.getValue() === "enable";
    const [isChecked, setIsChecked] = useState(initialChecked);
    const [isLoading, setIsLoading] = useState(false);

    const handleUpdate = (e) => {
        const newChecked = e.target.checked;
        // console.log(newChecked);
        setIsLoading(true);

        axios
            .put(
                `${apiKey}/api/rms/admin/update-master-ordertype-status/${row.row.original.id}`,
                {
                    [status]: newChecked ? "enable" : "disable",
                },
                {
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                }
            )
            .then((res) => {
                toast.success(res.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setIsChecked(newChecked);
            })
            .catch((err) => {
                handleError(err.response.data.message);
                toast.error(err.response.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <div className="relative">
            <input
                type="checkbox"
                onChange={handleUpdate}
                checked={isChecked}
                className="theme-checkbox"
            />
            {isLoading && (
                <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50 z-10 rounded-full">
                    <img
                        className="w-4 mx-auto"
                        src="/assets/gif/button_loader.gif"
                        alt=""
                    />
                </span>
            )}
        </div>
    );
}

function OrderTypes() {
    const user = JSON.parse(localStorage.getItem("rms-admin"));
    const columns = [
        {
            header: languageHelper("SN"),
            cell: (row) => row.row.index + 1,
        },
        {
            header: languageHelper("Type"),
            accessorKey: "type"
        },
        {
            header: languageHelper("Name"),
            accessorKey: "name",
        },
        {
            header: languageHelper("Status"),
            accessorKey: "status",
            cell: (row) => (
                <CheckBox
                    row={row}
                    status={"status"}
                    user={user}
                    handleError={setError}
                />
            ),
        },
    ];
    const [data, setData] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        axios
            .get(
                `${apiKey}/api/rms/admin/ordertype`,
                {
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                }
            )
            .then((res) => {
                setData(res.data);
            })
            .catch((err) => {
                setError(err?.response?.data.message || "Error Occured");
            })
            .finally(() => {
                setPageLoading(false);
            });
    }, [user?.token, user?.user.outlet_id]);

    if (pageLoading) {
        return (
            <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
                <img src="/assets/gif/dash2.gif" alt="" />
            </div>
        );
    }

    if (error) {
        return <MessageCard error={error} />;
    }

    return (
        <main>
            <CardTable data={data} columns={columns} heading={languageHelper("Order Type")} />
        </main>
    );
}

export default OrderTypes;
